/**
 * 🗺️ 地圖縮放控制項（含中軸縮放級數顯示）
 * 職責：在 Leaflet + 與 - 按鈕中間即時顯示目前縮放級數（Zoom Level）。
 */

export function attachZoomLevelControl(map) {
    if (!map || map._zoomLevelControl) return map._zoomLevelControl || null;

    const ZoomControl = L.Control.extend({
        options: {
            position: 'topleft',
            zoomInText: '+',
            zoomInTitle: '放大',
            zoomOutText: '&#x2212;',
            zoomOutTitle: '縮小'
        },

        onAdd(mapInstance) {
            this._map = mapInstance;
            const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-zoom-indicator');

            // 1. 放大按鈕 (+)
            const zoomInBtn = L.DomUtil.create('a', 'leaflet-control-zoom-in', container);
            zoomInBtn.href = '#';
            zoomInBtn.role = 'button';
            zoomInBtn.title = this.options.zoomInTitle;
            zoomInBtn.setAttribute('aria-label', this.options.zoomInTitle);
            zoomInBtn.innerHTML = this.options.zoomInText;

            // 2. 目前縮放級數 (中軸顯示)
            const zoomLevelEl = L.DomUtil.create('div', 'leaflet-control-zoom-level', container);
            zoomLevelEl.role = 'status';
            zoomLevelEl.setAttribute('aria-live', 'polite');

            // 3. 縮小按鈕 (-)
            const zoomOutBtn = L.DomUtil.create('a', 'leaflet-control-zoom-out', container);
            zoomOutBtn.href = '#';
            zoomOutBtn.role = 'button';
            zoomOutBtn.title = this.options.zoomOutTitle;
            zoomOutBtn.setAttribute('aria-label', this.options.zoomOutTitle);
            zoomOutBtn.innerHTML = this.options.zoomOutText;

            L.DomEvent.disableClickPropagation(container);
            L.DomEvent.disableScrollPropagation(container);

            L.DomEvent.on(zoomInBtn, 'click', (e) => {
                L.DomEvent.preventDefault(e);
                mapInstance.zoomIn();
            });

            L.DomEvent.on(zoomOutBtn, 'click', (e) => {
                L.DomEvent.preventDefault(e);
                mapInstance.zoomOut();
            });

            const updateZoom = () => {
                const z = Math.round(mapInstance.getZoom());
                zoomLevelEl.textContent = String(z);
                zoomLevelEl.title = `目前縮放級數：第 ${z} 級`;
                zoomLevelEl.setAttribute('aria-label', `目前縮放級數第 ${z} 級`);

                const minZoom = mapInstance.getMinZoom();
                const maxZoom = mapInstance.getMaxZoom();

                if (minZoom !== undefined && z <= minZoom) {
                    L.DomUtil.addClass(zoomOutBtn, 'leaflet-disabled');
                } else {
                    L.DomUtil.removeClass(zoomOutBtn, 'leaflet-disabled');
                }

                if (maxZoom !== undefined && z >= maxZoom) {
                    L.DomUtil.addClass(zoomInBtn, 'leaflet-disabled');
                } else {
                    L.DomUtil.removeClass(zoomInBtn, 'leaflet-disabled');
                }
            };

            mapInstance.on('zoomend zoom', updateZoom);
            updateZoom();

            this._container = container;
            this._updateZoom = updateZoom;
            return container;
        },

        onRemove(mapInstance) {
            if (this._updateZoom) {
                mapInstance.off('zoomend zoom', this._updateZoom);
            }
        }
    });

    const ctrl = new ZoomControl();
    ctrl.addTo(map);
    map._zoomLevelControl = ctrl;
    return ctrl;
}
